export default {
    name: 'FRC',
    src: require('../../assets/frc/robot.png'),
    alt: 'Robô de FRC',
    button: {
        text: 'Jogar FRC',
    },
}